import moment from 'moment';

/** Table keys excluded from persisted saved views and from filter-signature comparison. */
export const TRANSIENT_TABLE_PARAM_KEYS = ['page', 'search', 'sorting'];

const FILTER_PILL_IGNORE_KEYS = ['page', 'search'];

const paramValueIsActive = val => {
  if (val === undefined || val === null || val === '') return false;
  if (Array.isArray(val)) return val.length > 0;
  return true;
};

export const paramObjectHasActiveFilter = param => {
  if (param == null) return false;
  if (typeof param !== 'object' || Array.isArray(param)) {
    return paramValueIsActive(param);
  }
  return paramValueIsActive(param.value) || paramValueIsActive(param.name);
};

const stableStringify = v => {
  if (v === null || v === undefined || typeof v !== 'object' || Array.isArray(v))
    return JSON.stringify(v);
  return JSON.stringify(
    Object.fromEntries(Object.entries(v).sort(([a], [b]) => a.localeCompare(b))),
  );
};

const FILTER_PARAM_COMPARE_KEYS = ['type', 'value', 'name'];

const normalizeParamForFilterCompare = v => {
  if (v === null || v === undefined) return 'null';
  if (typeof v !== 'object' || Array.isArray(v)) return stableStringify(v);
  const picked = {};
  for (const key of FILTER_PARAM_COMPARE_KEYS) {
    if (v[key] !== undefined) picked[key] = v[key];
  }
  return stableStringify(
    Object.fromEntries(Object.entries(picked).sort(([a], [b]) => a.localeCompare(b))),
  );
};

/** Stable signature of active filter keys/values (ignores page/search/sorting). */
export const savedViewFilterSignature = queryParams =>
  JSON.stringify(
    Object.fromEntries(
      Object.entries(queryParams ?? {})
        .filter(
          ([k, v]) =>
            !TRANSIENT_TABLE_PARAM_KEYS.includes(k) &&
            v !== null &&
            v !== undefined &&
            paramObjectHasActiveFilter(v),
        )
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([k, v]) => [k, normalizeParamForFilterCompare(v)]),
    ),
  );

export const savedViewFilterSignaturesMatch = (a, b) =>
  savedViewFilterSignature(a) === savedViewFilterSignature(b);

export function stripTransientQueryParams(params) {
  if (!params || typeof params !== 'object') return {};
  return Object.fromEntries(
    Object.entries(params).filter(([k]) => !TRANSIENT_TABLE_PARAM_KEYS.includes(k)),
  );
}

export function buildReportingFilterPillsFromQueryParams(queryParams) {
  if (!queryParams || typeof queryParams !== 'object') return [];
  const pills = [];
  Object.keys(queryParams)
    .filter(k => !FILTER_PILL_IGNORE_KEYS.includes(k))
    .forEach(key => {
      const param = queryParams[key];
      if (!param) return;
      switch (param.type) {
        case 'date_range':
          if (param.value) {
            pills.push({
              title: param.title,
              value:
                moment(param.value[0]).format('MMM D, YYYY') +
                ' - ' +
                moment(param.value[1]).format('MMM D, YYYY'),
              isDate: true,
            });
          }
          break;
        case 'status': {
          const names = param.name;
          if (!names) break;
          if (Array.isArray(names)) {
            names.filter(Boolean).forEach(name => {
              pills.push({ title: param.title, value: name });
            });
          } else {
            pills.push({ title: param.title, value: names });
          }
          break;
        }
        default:
          break;
      }
    });
  return pills;
}
